import React from "react";
import { useNavigate } from "react-router-dom";
import "../App.css";

function PageNotFound() {
    const navigate = useNavigate();
    return (
        <div className="App">
            <h1 className="gap">Page Not Found</h1>
            <button className="login-btn" onClick={()=>navigate('/')}>Go to Homepage</button>

        </div>
    )
}

export default PageNotFound;